import moment from 'moment';
import { TIME_FORMAT } from '../components/Common/constants';

export const editReservationMergeSlot = (bookingSlot, availableSlots) => {
  let mergedSlots = [];
  let slotMerged = false;
  availableSlots.forEach((slot) => {
    let slotStartTime = slot.startTime;
    let slotEndTime = slot.endTime;

    if (moment(slot.startTime, TIME_FORMAT).isSame(moment(bookingSlot.endTime, TIME_FORMAT))) {
      slotStartTime = bookingSlot.startTime;
      slotMerged = true;
    }

    if (moment(slot.endTime, TIME_FORMAT).isSame(moment(bookingSlot.startTime, TIME_FORMAT))) {
      slotEndTime = bookingSlot.endTime;
      slotMerged = true;
    }

    if (!checkMergeSlots(slotStartTime, slotEndTime, mergedSlots)) {
      mergedSlots.push({
        startTime: slotStartTime,
        endTime: slotEndTime,
      });
    }
  });

  if (!slotMerged) {
    mergedSlots = [bookingSlot, ...mergedSlots];
  }
  return mergedSlots;
};

const checkMergeSlots = (slotStartTime, slotEndTime, mergedSlots) => {
  let conflicktSlots = false;

  mergedSlots.forEach((mergSlot) => {
    if (
      moment(slotStartTime, TIME_FORMAT).isSameOrBefore(moment(mergSlot.endTime, TIME_FORMAT)) &&
      moment(slotStartTime, TIME_FORMAT).isAfter(moment(mergSlot.startTime, TIME_FORMAT))
    ) {
      mergSlot.endTime = slotEndTime;
      conflicktSlots = true;
    } else if (
      moment(slotEndTime, TIME_FORMAT).isSameOrAfter(moment(mergSlot.startTime, TIME_FORMAT)) &&
      moment(slotEndTime, TIME_FORMAT).isBefore(moment(mergSlot.endTime, TIME_FORMAT))
    ) {
      mergSlot.endTime = slotStartTime;
      conflicktSlots = true;
    }
  });

  return conflicktSlots;
};
